import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/family-space/family-space-hero.webp'
import _imports_1 from '@/assets/family-space/f-1.webp'
import _imports_2 from '@/assets/family-space/f-2.webp'
import _imports_3 from '@/assets/family-space/f-3.webp'
import _imports_4 from '@/assets/family-space/f-4.webp'
import _imports_5 from '@/assets/family-space/f-5.webp'
import _imports_6 from '@/assets/family-space/f-6.webp'
import _imports_7 from '@/assets/family-space/f-7.webp'
import _imports_8 from '@/assets/family-space/f-8.webp'
import _imports_9 from '@/assets/grass-wide.webp'


const _hoisted_1 = { class: "flex flex-col max-w-full mx-auto gap-y-16 md:gap-y-32" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col md:flex-row gap-10 md:max-w-[95%] lg:max-w-[1120px] mx-auto mt-10 md:mt-20 w-full items-center px-7 md:px-0\"><img src=\"" + _imports_0 + "\" class=\"md:hidden\"><div class=\"max-w-full md:max-w-[360px] flex flex-col gap-6\"><div class=\"font-bold text-[32px] md:text-[52px] text-secondary-gray md:text-green leading-tight font-georgian w-52 md:w-auto\"> The Perfect Family Space </div><div class=\"text-sm leading-relaxed\"><span class=\"text-light-green font-bold\">Enjoy amazing family moments on your new carefree lawn.</span><br><br><span class=\"text-primary-gray\"> ProGreen Canada is Most Trusted Artificial Turf unlike turf manufactured overseas, which is often of poor quality and may contain lead or other heavy metals. Be confident that ProGreen Synthetic Turf Systems is <span class=\"text-light-green font-bold\">100% lead </span>and <span class=\"text-light-green font-bold\">heavy metal-free</span> and manufactured using the industry&#39;s highest quality standards. </span></div></div><div class=\"ml-auto w-full max-w-[670px] hidden md:block\"><img src=\"" + _imports_0 + "\"></div></div>", 1)
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-center gap-6 md:gap-10\"><div class=\"md:uppercase font-bold font-georgian text-2xl md:text-[42px] text-green\"> Our work </div><div class=\"grid grid-cols-2 md:grid-cols-4 gap-1\"><img src=\"" + _imports_1 + "\"><img src=\"" + _imports_2 + "\"><img src=\"" + _imports_3 + "\"><img src=\"" + _imports_4 + "\"><img src=\"" + _imports_5 + "\"><img src=\"" + _imports_6 + "\"><img src=\"" + _imports_7 + "\"><img src=\"" + _imports_8 + "\"></div></div>", 1)
const _hoisted_4 = { class: "relative w-full max-w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 bottom-0 left-0 right-0 items-center z-0 hidden md:flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    class: "w-full h-60"
  })
], -1)
const _hoisted_6 = { class: "flex flex-col items-center gap-10 z-10 relative max-w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl text-green md:text-[32px] leading-normal font-bold font-georgian text-center" }, [
  /*#__PURE__*/_createTextVNode(" Our most popular "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("family space solutions ")
], -1)
const _hoisted_8 = { class: "flex gap-2 lg:gap-4 flex-wrap items-center justify-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-light-green" }, "medium to heavy trafﬁc", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-light-green" }, "for heavy trafﬁc", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-light-green" }, "lush and dense", -1)

import SolutionCard from "@/components/family-space/solution-card.vue";
import SectionGrassBg from "@/components/family-space/section-grass-bg.vue";
import SectionGrassBgMobile from "@/components/family-space/section-grass-bg-mobile.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FamilySpace',
  setup(__props) {

// import FilledButton from "@/components/common/filled-button.vue";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(SectionGrassBg, { class: "hidden md:block" }),
    _createVNode(SectionGrassBgMobile, { class: "md:hidden" }),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(SolutionCard, null, {
            title: _withCtx(() => [
              _createTextVNode("Natural Real Premium 60")
            ]),
            price: _withCtx(() => [
              _createTextVNode("$7.50")
            ]),
            height: _withCtx(() => [
              _createTextVNode("1.125”")
            ]),
            weight: _withCtx(() => [
              _createTextVNode("60 oz")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Ideal for "),
              _hoisted_9,
              _createTextVNode(" applications. This turf utilizes a mix of “diamond” and “S” shaped blades 1.5\" long that provides the ultimate softness that you can expect from ProGreen turf with improved resiliency. ")
            ]),
            _: 1
          }),
          _createVNode(SolutionCard, null, {
            title: _withCtx(() => [
              _createTextVNode("Natural Real Supreme 75")
            ]),
            price: _withCtx(() => [
              _createTextVNode("$8.50")
            ]),
            height: _withCtx(() => [
              _createTextVNode("1.125”")
            ]),
            weight: _withCtx(() => [
              _createTextVNode("75 oz")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Ideal "),
              _hoisted_10,
              _createTextVNode(" applications and is designed to withstand even the harshest conditions while maintaining a lush, natural appearance. "),
              _hoisted_11,
              _createTextVNode("This turf utilizes a mix of diamond and “S” shaped blades 1.75\" long, allowing the turf to stay upright while maintaining ProGreen's signature softness. ")
            ]),
            _: 1
          }),
          _createVNode(SolutionCard, null, {
            title: _withCtx(() => [
              _createTextVNode("Natural Real Platinum 110")
            ]),
            price: _withCtx(() => [
              _createTextVNode("$9.99")
            ]),
            height: _withCtx(() => [
              _createTextVNode("1.125”")
            ]),
            weight: _withCtx(() => [
              _createTextVNode("110 oz")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Our most luxurious product, \"Natural Real Platinum 110\" is more "),
              _hoisted_12,
              _createTextVNode(" than any artiﬁcial grass product in the industry. It creates a ﬂawless aesthetic with incredible durability, all while maintaining ProGreen’s signature softness. ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})